import { EscalationRecipientRole } from "@/models/enum";
import { TranslationKey } from "@/types/translations";

export const timezoneOptions = [
    // North America
    { value: "America/New_York", label: "Eastern Time (ET)", offset: "UTC-5/-4" },
    { value: "America/Chicago", label: "Central Time (CT)", offset: "UTC-6/-5" },
    { value: "America/Denver", label: "Mountain Time (MT)", offset: "UTC-7/-6" },
    { value: "America/Los_Angeles", label: "Pacific Time (PT)", offset: "UTC-8/-7" },
    { value: "America/Phoenix", label: "Arizona Time (MST)", offset: "UTC-7" },
    { value: "America/Anchorage", label: "Alaska Time (AKST)", offset: "UTC-9/-8" },
    { value: "Pacific/Honolulu", label: "Hawaii Time (HST)", offset: "UTC-10" },
    { value: "America/Toronto", label: "Eastern Time (Canada)", offset: "UTC-5/-4" },
    { value: "America/Vancouver", label: "Pacific Time (Canada)", offset: "UTC-8/-7" },
    { value: "America/Edmonton", label: "Mountain Time (Canada)", offset: "UTC-7/-6" },
    { value: "America/Winnipeg", label: "Central Time (Canada)", offset: "UTC-6/-5" },
    { value: "America/Halifax", label: "Atlantic Time (Canada)", offset: "UTC-4/-3" },
    { value: "America/St_Johns", label: "Newfoundland Time", offset: "UTC-3:30/-2:30" },
    { value: "America/Mexico_City", label: "Mexico City Time", offset: "UTC-6/-5" },
    
    // South America
    { value: "America/Sao_Paulo", label: "Brasília Time", offset: "UTC-3/-2" },
    { value: "America/Buenos_Aires", label: "Argentina Time", offset: "UTC-3" },
    { value: "America/Santiago", label: "Chile Time", offset: "UTC-4/-3" },
    { value: "America/Lima", label: "Peru Time", offset: "UTC-5" },
    { value: "America/Bogota", label: "Colombia Time", offset: "UTC-5" },
    { value: "America/Caracas", label: "Venezuela Time", offset: "UTC-4" },
    
    // Europe
    { value: "Europe/London", label: "Greenwich Mean Time (GMT)", offset: "UTC+0/+1" },
    { value: "Europe/Dublin", label: "Irish Time", offset: "UTC+0/+1" },
    { value: "Europe/Paris", label: "Central European Time (CET)", offset: "UTC+1/+2" },
    { value: "Europe/Berlin", label: "Central European Time (CET)", offset: "UTC+1/+2" },
    { value: "Europe/Madrid", label: "Central European Time (Spain)", offset: "UTC+1/+2" },
    { value: "Europe/Rome", label: "Central European Time (Italy)", offset: "UTC+1/+2" },
    { value: "Europe/Amsterdam", label: "Central European Time (Netherlands)", offset: "UTC+1/+2" },
    { value: "Europe/Zurich", label: "Central European Time (Switzerland)", offset: "UTC+1/+2" },
    { value: "Europe/Vienna", label: "Central European Time (Austria)", offset: "UTC+1/+2" },
    { value: "Europe/Stockholm", label: "Central European Time (Sweden)", offset: "UTC+1/+2" },
    { value: "Europe/Oslo", label: "Central European Time (Norway)", offset: "UTC+1/+2" },
    { value: "Europe/Copenhagen", label: "Central European Time (Denmark)", offset: "UTC+1/+2" },
    { value: "Europe/Warsaw", label: "Central European Time (Poland)", offset: "UTC+1/+2" },
    { value: "Europe/Prague", label: "Central European Time (Czech Republic)", offset: "UTC+1/+2" },
    { value: "Europe/Budapest", label: "Central European Time (Hungary)", offset: "UTC+1/+2" },
    { value: "Europe/Athens", label: "Eastern European Time (Greece)", offset: "UTC+2/+3" },
    { value: "Europe/Helsinki", label: "Eastern European Time (Finland)", offset: "UTC+2/+3" },
    { value: "Europe/Bucharest", label: "Eastern European Time (Romania)", offset: "UTC+2/+3" },
    { value: "Europe/Moscow", label: "Moscow Time", offset: "UTC+3" },
    { value: "Europe/Istanbul", label: "Turkey Time", offset: "UTC+3" },
    
    // Asia
    { value: "Asia/Tokyo", label: "Japan Standard Time (JST)", offset: "UTC+9" },
    { value: "Asia/Shanghai", label: "China Standard Time (CST)", offset: "UTC+8" },
    { value: "Asia/Hong_Kong", label: "Hong Kong Time", offset: "UTC+8" },
    { value: "Asia/Singapore", label: "Singapore Time", offset: "UTC+8" },
    { value: "Asia/Seoul", label: "Korea Standard Time", offset: "UTC+9" },
    { value: "Asia/Bangkok", label: "Indochina Time", offset: "UTC+7" },
    { value: "Asia/Jakarta", label: "Western Indonesia Time", offset: "UTC+7" },
    { value: "Asia/Manila", label: "Philippine Time", offset: "UTC+8" },
    { value: "Asia/Kuala_Lumpur", label: "Malaysia Time", offset: "UTC+8" },
    { value: "Asia/Taipei", label: "Taipei Time", offset: "UTC+8" },
    { value: "Asia/Kolkata", label: "India Standard Time (IST)", offset: "UTC+5:30" },
    { value: "Asia/Dhaka", label: "Bangladesh Time", offset: "UTC+6" },
    { value: "Asia/Karachi", label: "Pakistan Time", offset: "UTC+5" },
    { value: "Asia/Dubai", label: "Gulf Standard Time", offset: "UTC+4" },
    { value: "Asia/Riyadh", label: "Arabia Standard Time", offset: "UTC+3" },
    { value: "Asia/Tehran", label: "Iran Time", offset: "UTC+3:30/+4:30" },
    { value: "Asia/Jerusalem", label: "Israel Time", offset: "UTC+2/+3" },
    { value: "Asia/Yekaterinburg", label: "Yekaterinburg Time", offset: "UTC+5" },
    { value: "Asia/Novosibirsk", label: "Novosibirsk Time", offset: "UTC+7" },
    { value: "Asia/Vladivostok", label: "Vladivostok Time", offset: "UTC+10" },
    
    // Africa
    { value: "Africa/Cairo", label: "Eastern European Time (Egypt)", offset: "UTC+2" },
    { value: "Africa/Johannesburg", label: "South Africa Time", offset: "UTC+2" },
    { value: "Africa/Lagos", label: "West Africa Time", offset: "UTC+1" },
    { value: "Africa/Nairobi", label: "East Africa Time", offset: "UTC+3" },
    { value: "Africa/Casablanca", label: "Western European Time (Morocco)", offset: "UTC+0/+1" },
    { value: "Africa/Algiers", label: "Central European Time (Algeria)", offset: "UTC+1" },
    
    // Australia & Oceania
    { value: "Australia/Sydney", label: "Australian Eastern Time (AEST)", offset: "UTC+10/+11" },
    { value: "Australia/Melbourne", label: "Australian Eastern Time (AEST)", offset: "UTC+10/+11" },
    { value: "Australia/Brisbane", label: "Australian Eastern Time (AEST)", offset: "UTC+10" },
    { value: "Australia/Perth", label: "Australian Western Time (AWST)", offset: "UTC+8" },
    { value: "Australia/Adelaide", label: "Australian Central Time (ACST)", offset: "UTC+9:30/+10:30" },
    { value: "Australia/Darwin", label: "Australian Central Time (ACST)", offset: "UTC+9:30" },
    { value: "Pacific/Auckland", label: "New Zealand Time", offset: "UTC+12/+13" },
    { value: "Pacific/Fiji", label: "Fiji Time", offset: "UTC+12/+13" },
    { value: "Pacific/Guam", label: "Chamorro Time", offset: "UTC+10" },
    
    // Atlantic
    { value: "Atlantic/Azores", label: "Azores Time", offset: "UTC-1/+0" },
    { value: "Atlantic/Reykjavik", label: "Greenwich Mean Time (Iceland)", offset: "UTC+0" },
]
  
export const escalationRoleOptions = [
    { value: EscalationRecipientRole.AssignedTo, label: "Assigned To", description: "Person assigned to manage this worker/client" },
    { value: EscalationRecipientRole.JobOwner, label: "Job Owner", description: "Owner of the job/project" },
    { value: EscalationRecipientRole.Recruiter, label: "Recruiter", description: "Recruiter responsible for this placement" },
]

// Function to get escalation role options with translations
type TKey = (key: TranslationKey, variables?: Record<string, any>) => string
export const getEscalationRoleOptions = (t: TKey) => [
    { 
        value: EscalationRecipientRole.AssignedTo, 
        label: t("dashboard.editReminder.escalationRoles.assignedTo"), 
        description: t("dashboard.editReminder.escalationRoles.assignedToDescription") 
    },
    { 
        value: EscalationRecipientRole.JobOwner, 
        label: t("dashboard.editReminder.escalationRoles.jobOwner"), 
        description: t("dashboard.editReminder.escalationRoles.jobOwnerDescription") 
    },
    { 
        value: EscalationRecipientRole.Recruiter, 
        label: t("dashboard.editReminder.escalationRoles.recruiter"), 
        description: t("dashboard.editReminder.escalationRoles.recruiterDescription") 
    },
]